/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response containing location data and calculated score.
 * @export
 * @interface PlaceScoreResponse
 */
export interface PlaceScoreResponse {
    /**
     * Map of location types to arrays of location names.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof PlaceScoreResponse
     */
    locationsByType: { [key: string]: Array<string>; };
    /**
     * Calculated score based on nearby places. Higher is better.
     * @type {number}
     * @memberof PlaceScoreResponse
     */
    score: number;
}

/**
 * Check if a given object implements the PlaceScoreResponse interface.
 */
export function instanceOfPlaceScoreResponse(value: object): value is PlaceScoreResponse {
    if (!('locationsByType' in value) || value['locationsByType'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function PlaceScoreResponseFromJSON(json: any): PlaceScoreResponse {
    return PlaceScoreResponseFromJSONTyped(json, false);
}

export function PlaceScoreResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaceScoreResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'locationsByType': json['locationsByType'],
        'score': json['score'],
    };
}

export function PlaceScoreResponseToJSON(json: any): PlaceScoreResponse {
    return PlaceScoreResponseToJSONTyped(json, false);
}

export function PlaceScoreResponseToJSONTyped(value?: PlaceScoreResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationsByType': value['locationsByType'],
        'score': value['score'],
    };
}

